import { format, isValid, parse } from 'date-fns';
import { numericFormatter } from 'react-number-format';

export const formatPhoneNumber = (phoneNumber: string) => {
  const output = numericFormatter(phoneNumber, {
    valueIsNumericString: true,
    value: phoneNumber,
    type: 'tel',
    thousandSeparator: ' ',
  });

  return output;
};

export const formatPrice = (price: number | string) => {
  const priceFormatted = numericFormatter(price.toString(), { thousandSeparator: '\u00A0', decimalSeparator: ',' });
  return priceFormatted;
};

const dateFormat = 'dd.MM.yyyy' as const;
const timeFormat = 'HH:mm' as const;
export const formatDateWithTime = (date: Date) => {
  if (isValid(date)) {
    return format(date, `${dateFormat} ${timeFormat}`);
  }
  return null;
};

export const formatDate = (date: Date) => {
  if (isValid(date)) {
    return format(date, dateFormat);
  }
  return null;
};

export const parseDate = (date: string) => {
  return parse(date, `${dateFormat} ${timeFormat}`, new Date());
};

export const removeTags = (str?: string) => {
  if (!str) return false;
  else str = str.toString();

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, ' ');
};
